<template>
    <b-row class="match-height">
      <b-col
lg="12"
> <b-card
      title="Send Material Request"
    >
      <b-form
          @submit.prevent="submitEditMaterialRequest"
>
        <b-row>
          <b-col cols="12">
            <b-button
            type="button"
            variant="primary"
            class="mr-1"
            @click="previous()"
            >
            <feather-icon
                icon="ArrowLeftIcon"
                size="16"
                class="align-middle"
            />
            Back
            </b-button>
            <div class="devider" />
          <b-form-group>
            <label for="email">Number :</label>
            <input
              v-model="materialRequestNumber"
              type="text"
              name="Number"
              class="form-control"
              readonly
              >
          </b-form-group>
            <b-form-group
              label="To *"
              label-for="material_request_to"
              label-cols-md="12"
            >
              <b-form-input
                id="material_request_to"
                v-model="materialRequestTo"
                placeholder="To."
                required="required"
                readonly
              />
            </b-form-group>
            <b-form-group
              label="CC"
              label-for="material_request_cc"
              label-cols-md="12"
            >
              <b-form-input
                id="material_request_cc"
                v-model="materialRequestCc"
                placeholder="CC"
                required="required"
                readonly
              />
            </b-form-group>
            <b-form-group
              label="Reason"
              label-for="material_request_reason"
              label-cols-md="12"
            >
              <b-form-input
                id="material_request_reason"
                v-model="materialRequestReason"
                placeholder="Reason"
                required="required"
                readonly
              />
            </b-form-group>
            <b-row>
              <b-col
cols="4"
class="text-center font-weight-bold"
>
                Item name
              </b-col>
              <b-col
cols="2"
class="text-center font-weight-bold"
>
                Item Unit
              </b-col>
              <b-col
cols="1"
class="text-center font-weight-bold"
>
                Req QTY
              </b-col>
              <b-col
cols="1"
class="text-center font-weight-bold"
>
                Acc QTY
              </b-col>
              <b-col
cols="1"
class="text-center font-weight-bold"
>
                Stock
              </b-col>
              <b-col
cols="1"
class="text-center font-weight-bold"
>
                Sent QTY
              </b-col>
              <b-col
cols="1"
class="text-center font-weight-bold"
>
                Shelf
              </b-col>
              <b-col
cols="1"
class="text-center font-weight-bold"
>
                Is Final
              </b-col>
              </b-row>
             <p />
            <b-row
v-for="(chosen) in chosens"
:key="chosen.value"
>
            <br>
              <b-col
cols="4"
class="text-center"
>
                  <b-list-group>
                    <b-list-group-item href="#">
{{ chosen.label }}
</b-list-group-item>
                  </b-list-group>
                </b-col>
              <b-col
cols="2"
class="text-center"
>
                  <b-list-group>
                    <b-list-group-item href="#">
{{ chosen.unit_name }}
</b-list-group-item>
                  </b-list-group>
                </b-col>
              <b-col
cols="1"
class="text-center"
>
              <b-form-input
                v-model="chosen.qty"
                placeholder="Qty"
                min="1"
                readonly
              />
              </b-col>
              <b-col
cols="1"
class="text-center"
>
              <b-form-input
                v-model="chosen.qty_accepted"
                placeholder="Qty Accepted"
                min="1"
                readonly
              />
              </b-col>
              <b-col
cols="1"
class="text-center"
>
              <b-form-input
                v-model="chosen.current_available"
                placeholder="Stock"
                min="1"
                readonly
              />
              </b-col>
              <b-col
cols="1"
class="text-center"
>
              <b-form-input
                v-if="materialRequestSent==false && chosen.current_available>0 && chosen.lock == false && chosen.isDisabled == false"
                v-model="chosen.qty_sent"
                :disabled="chosen.isDisabled"
                type="number"
                placeholder="Qty"
                :max="chosen.qty_leftover"
              />
              <b-form-input
                v-if="materialRequestSent==false && chosen.current_available>0 && chosen.lock == true && chosen.isDisabled == false"
                v-model="chosen.qty_sent"
                type="number"
                placeholder="Qty"
                :max="chosen.qty_leftover"
              />
              <b-form-input
                v-if="materialRequestSent==true && chosen.current_available>0 && chosen.isDisabled == false"
                v-model="chosen.qty_sent"
                :disabled="chosen.isDisabled"
                placeholder="Qty"
                min="0"
                readonly
              />
              </b-col>
            <b-col
cols="1"
class="text-center"
>
              <v-select-new
                    v-if="materialRequestSent==false && chosen.current_available>0 && chosen.isDisabled == false"
                    v-model="chosen.shelf"
                    :options="chosen.shelves"
                    :disabled="chosen.isDisabled"
                    :reduce="val => val.value"
                  />
            </b-col>
              <b-col
cols="1"
class=" text-center float-center"
>
                <b-form-checkbox
                  v-if="materialRequestSent==false && chosen.current_available>0 && chosen.isDisabled == false"
                  v-model="chosen.is_final"
                    class="mb-1 float-center"
                />
              </b-col>
              <b-col cols="12">
                <br>
              </b-col>
              </b-row>
          </b-col>
          <!-- submit and reset -->
          <b-col offset-md="12">
            <b-button
              v-if="!materialRequestSent"
              type="submit"
              variant="primary"
              class="mr-1"
            :disabled="submitButtonDisabled"
            >
              Submit
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
      </b-col>
    </b-row>
  </template>
  <script>
  import {
    BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BCard, BListGroup, BListGroupItem, BFormCheckbox, BFormCheckboxGroup,
    } from 'bootstrap-vue'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import axios from 'axios'
  import moment from 'moment-timezone'
  import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import apiEndpoints from '@/constants/apiEndpoints'

  const VersionCheck = ''
  const items = []
  const chosenItem = ref(3)
  const chosens = []
  const shelves = []
  const materialRequestNumber = ''
  const materialRequestTo = ''
  const materialRequestCc = ''
  const materialRequestReason = ''
  const materialRequestQtySent = 0
  const materialRequestStatus = ''
  const materialRequestId = ''
  const materialRequestSent = false
  const isOutOfStock = false
  const submitButtonDisabled = false
  const numOutOfStock = 0
  export default {
    components: {
      BFormCheckbox,
      BFormCheckboxGroup,
      BListGroup,
      BListGroupItem,
      BCard,
      BRow,
      BCol,
      BFormGroup,
      BFormInput,
      BForm,
      BButton,
    },
    directives: {
      Ripple,
    },
    data() {
      return {
        shelves,
     materialRequestId,
      VersionCheck,
      items,
      chosenItem,
      chosens,
      materialRequestNumber,
      materialRequestTo,
      materialRequestCc,
      materialRequestReason,
      materialRequestQtySent,
      materialRequestStatus,
      materialRequestSent,
      isOutOfStock,
      submitButtonDisabled,
      numOutOfStock,
      }
    },
  created() {
    window.setInterval(() => {
      this.removeReadOnly()
    }, 1000)
  },
    mounted() {
    const shelfsVariables = process.env.VUE_APP_SHELF_LIST.split(",")
    const shelfsRepeat = process.env.VUE_APP_SHELF_REPEAT.split(",")
    this.shelves = []
    shelfsVariables.map(s => {
      shelfsRepeat.map(r => {
        this.shelves.push(`${s}${r}`)
      })
    })
        this.getDetail()
    },
    methods: {
    removeReadOnly() {
    const searches = document.getElementsByClassName('vs__search')
    for (let i = 0; i < searches.length; i += 1) {
      searches[i].removeAttribute('readonly')
}
    },
    getDetail() {
      const userToken = this.$cookies.get('userToken')
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userToken}`,
  }
      const item = JSON.parse(localStorage.getItem('materialRequestDetail'))
      this.modalDetailShow = true
      this.materialRequestNumber = item.material_request_number
      this.materialRequestTo = item.material_request_to
      this.materialRequestCc = item.material_request_cc
      this.materialRequestReason = item.material_request_reason
      this.materialRequestId = item.material_request_id
      const id = item.material_request_id
      this.materialRequestId = id
      this.materialRequestSent = item.material_request_is_accepted_by_warehouse
      axios
      .get(`${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_MATERIAL_REQUEST_DETAILS}${id}`, { headers })
      .then(response => {
        if (response.data.success === true) {
        const itemsJoin = []
        response.data.data.map(elem => {
          if (elem.material_request_detail_is_out_of_stock === true) {
            this.isOutOfStock = true
          }
          const isDisabled = elem.material_request_detail_item_qty_sent === elem.material_request_detail_item_qty_accepted ? true : false
          const leftover = elem.material_request_detail_item_qty_sent < elem.material_request_detail_item_qty_accepted ? elem.material_request_detail_item_qty_accepted - elem.material_request_detail_item_qty_sent : elem.material_request_detail_item_qty_accepted
          const temp = {
                id: elem.material_request_detail_id,
                label: `${elem.item.item_name} (${elem.item.item_code})`,
                value: elem.material_request_detail_item_id,
                qty: elem.material_request_detail_item_qty_requested,
                qty_accepted: elem.material_request_detail_item_qty_accepted,
                unit_name: elem.item.unit ? elem.item.unit.unit_name : '-',
                qty_sent: leftover,
                qty_leftover: leftover,
                isDisabled,
                is_final: false,
                out_of_stock: elem.material_request_detail_is_out_of_stock === true ? true : false,
                current_available: elem.current_available,
                shelves: elem.shelves,
                shelf: null,
                // FIX (by Fikri, 2026-07-06): separate flag for "no shelf needed" cases (out of
                // stock / already fully sent), instead of overloading `shelf` with a status string
                // like "Filled"/"Out of Stock". That string used to get sent to the backend and
                // written straight into stock_details.stock_detail_item_shelves, corrupting the
                // ledger's shelf column for every such Material Request line.
                shelf_not_required: false,
                lock: false,
            }
            if (elem.material_request_detail_item_qty_accepted > elem.current_available) {
              temp.qty_sent = elem.current_available
              temp.lock = true
            }
            itemsJoin.push(temp)
          })

        this.chosens = itemsJoin
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fetching Data success',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
        } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fetching Data failed',
                icon: 'CheckIcon',
                variant: 'danger',
              },
            })
        }
        })
    },
    submitEditMaterialRequest() {
      const userToken = this.$cookies.get('userToken')
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userToken}`,
  }
      this.submitButtonDisabled = true
      this.materialRequestQtySent = 0
      let shelfFilledCount = 0
      this.chosens.map(o => {
        // FIX (by Fikri, 2026-07-06): was `o.shelf = "Out of Stock"` / `o.shelf = "Filled"` here,
        // which overwrote the real shelf field with a status string. That polluted string then got
        // submitted to the backend and stored directly in stock_details.stock_detail_item_shelves,
        // breaking any future lookup/reconciliation keyed on (item, branch, shelf). Use a dedicated
        // flag instead so `o.shelf` stays either a real shelf code or null.
        if (o.current_available === 0) {
          this.numOutOfStock += o.qty_accepted
          o.shelf_not_required = true
        }
        if (o.isDisabled === true) {
          o.shelf_not_required = true
          o.qty_sent = 0
        }
        if ((o.shelf !== '' && o.shelf !== null) || o.shelf_not_required === true) {
          shelfFilledCount += 1
        }
      })
      this.chosens.map(elem => {
        this.materialRequestQtySent += parseInt(elem.qty_sent)
      })
      if (shelfFilledCount === this.chosens.length) {
        const body = {
          material_request_id: this.materialRequestId,
          material_request_to: this.materialRequestTo,
          material_request_cc: this.materialRequestCc,
          material_request_reason: this.materialRequestReason,
          material_request_qty_sent: this.materialRequestQtySent,
          material_request_is_accepted_by_warehouse: true,
          material_request_items: JSON.stringify(this.chosens),
          numOutOfStock: this.numOutOfStock,
          time: moment(),
        }
      axios
        .post(`${process.env.VUE_APP_API_URL}${apiEndpoints.API_SEND_MATERIAL_REQUEST}`, body, { headers })
        .then(response => {
          if (response.data.success === true) {
            this.chosens = []
            this.materialRequestQtySent = 0
            this.materialRequestReason = ""
            this.materialRequestCc = ""
            this.materialRequestTo = ""
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Update Material Request Success',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            this.$router.replace({ name: 'apps-material-request-list' })
          } else {
            this.submitButtonDisabled = false
          this.$toast({
            component: ToastificationContent,
            props: {
                title: response.data.message,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          }
          })
        .catch(e => {
            this.submitButtonDisabled = false
          this.$toast({
            component: ToastificationContent,
            props: {
                title: (e.response && e.response.data && e.response.data.message) || 'Material Request Failed',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
      } else {
            this.submitButtonDisabled = false
          this.$toast({
            component: ToastificationContent,
            props: {
                title: 'You have to fill all shelf',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
      }
    },
      getOptionLabel(option) {
        return (option && option.label) || ''
      },
      putItem(val) {
        if (this.chosens.length > 0) {
              let item = null
              this.items.map(elem => {
                if (elem.value === val.value) {
                  item = {
                    label: elem.label, value: elem.value, qty: 1, shelf: '',
                  }
                }
              })
            this.chosens.push(item)
        } else {
              let item = null
              this.items.map(elem => {
                if (elem.value === val.value) {
                  item = {
                    label: elem.label, value: elem.value, qty: 1, shelf: '',
                  }
                }
            })
            this.chosens.push(item)
        }
      },
      getOptionKey(option) {
        return (option && option.value) || ''
      },
      inputSearch(search) {

      },
      removeRow(val) {
        this.chosens = this.chosens.filter(obj => (obj.value !== val))
      },
      dateFormat(value, format = 'MM/DD/YYYY') {
          return moment.utc(value).tz('Asia/Jakarta').format(format)
      },
      previous() {
          this.$router.push({ name: 'apps-material-request-list' })
      },
    },
  }
  </script>
